module.exports = __webpack_public_path__ + "static/media/sun-weather.ec26d49b.gif";